<div class="mt-1">
  <p-selectButton
    [options]="calViews"
    (onChange)="calViewChanged($event)"
    [(ngModel)]="selCalView"
    optionLabel="label"
    optionValue="value"></p-selectButton>
</div>
<div class="mt-1" *ngIf="isInitialLoad" #calendarContainer>
  <full-calendar #calendar [options]="calendarOptions" [deepChangeDetection]="true"></full-calendar>
</div>
<p-popover #op [dismissable]="true" appendTo="body">
  <div *ngIf="popupRequest !== null && popupRequest !== undefined">
    <div><strong>Order Item Type:</strong> {{ popupRequest.ItemType }}</div>
    <div><strong>Container:</strong> {{ popupRequest.ContainerName }}</div>
    <div><strong>Delivery Location:</strong> {{ popupRequest.DeliveryLocationName }}</div>
    <div><strong>Order Item Desc:</strong> {{ popupRequest[itemDescName] }}</div>
    <div><strong>Order Item Instance Id:</strong> {{ popupRequest.InstanceSequence }}</div>
    <div><strong>Status:</strong> {{ popupRequest.InstanceStatus }}</div>
    <div style="white-space: pre-wrap"><strong>Note:</strong> {{ popupRequest.Note }}</div>
  </div>
</p-popover>

<p-dialog
  [header]="'Events - ' + (selectedDateEvents.length ? (selectedDateEvents[0].start | date: 'longDate') : '')"
  [(visible)]="displayMoreDialog"
  [modal]="true"
  [style]="dialogStyle"
  [contentStyle]="{ 'max-height': dialogMaxHeight, 'overflow': 'auto' }"
  [draggable]="true"
  [resizable]="false"
  appendTo="body">
  <div>
    <div
      *ngFor="let event of selectedDateEvents"
      class="p-2 mb-2 border-round cursor-pointer"
      [ngStyle]="{
        'background-color': event.backgroundColor || '#4caf50',
        'color': event.textColor || '#fff'
      }"
      (mouseenter)="handleDialogMouseEnter(event, $event)"
      (mouseleave)="handleDialogMouseLeave()">
      <ng-container *ngFor="let icon of event.extendedProps?.icons; let i = index">
        <i
          *ngIf="icon"
          class="fa-solid {{ icon }}"
          [ngStyle]="{
            'margin-left': i === 0 ? '2px' : '0px',
            'margin-right': i === 1 && event.extendedProps?.icons?.length === 3 ? '0px' : '7px'
          }">
        </i>
      </ng-container>

      {{ event.display }}
    </div>
  </div>
</p-dialog>
